import React from 'react';
import ReactDOM from 'react-dom/client';

// Inter staat als vijfde in de --font-stack in styles.css. Op macOS komt hij
// nooit aan bod (SF Pro staat eerder), op Windows wel. Tot 12-08-2026 werd hij
// bij fonts.googleapis.com opgehaald; nu zit hij in de app zelf. Zo gaat er
// geen bezoekersadres meer naar Google en hoeven fonts.googleapis.com en
// fonts.gstatic.com niet in de CSP. Alleen de latin-subset, dat scheelt.
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/inter/latin-700.css';

import './styles.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
